import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-professional-bodies-ec.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-professional-bodies-ec.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ViewApplicationProfessionalBodiesEcConstants } from "./view-application-professional-bodies-ec.constants";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../shared/models/alert";
let ViewApplicationProfessionalBodiesEcComponent = class ViewApplicationProfessionalBodiesEcComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    routerParamsService;
    professionalBodiesForm;
    professionalBodiesFormControlName = ViewApplicationProfessionalBodiesEcConstants.PROFESSIONAL_BODY_FORM_CONTROL_NAME;
    markEngineerAsRequiredLabel = ViewApplicationProfessionalBodiesEcConstants.MARK_ENGINEER_REQUIRED_LABEL;
    markEngineerAsRequiredFormControlName = ViewApplicationProfessionalBodiesEcConstants.MARK_ENGINEER_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToElectricalContractorLabel = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_LABEL;
    copyApplicantDetailsToElectricalContractorFormControlName = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    markElectricalContractorAsRequiredLabel = ViewApplicationProfessionalBodiesEcConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_LABEL;
    markElectricalContractorAsRequiredFormControlName = ViewApplicationProfessionalBodiesEcConstants.MARK_ELECTRICAL_CONTRACTOR_AS_REQUIRED_FORM_CONTROL_NAME;
    copyApplicantDetailsToEngineerLabel = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_LABEL;
    copyApplicantDetailsToEngineerFormControlName = ViewApplicationProfessionalBodiesEcConstants.COPY_APPLICANT_DETAILS_TO_ENGINEER_FORM_CONTROL_NAME;
    engineerFormControlName = ViewApplicationProfessionalBodiesEcConstants.ENGINEER_FORM_CONTROL_NAME;
    contractorFormControlName = ViewApplicationProfessionalBodiesEcConstants.ELECTRICAL_CONTRACTOR_FORM_CONTROL_NAME;
    showEngineer = false;
    showElectricalContractor = false;
    engineerDisableFilterBy = true;
    engineerDisableAdd = true;
    engineerDisableEditing = false;
    engineerShowFields = true;
    engineerIsInternal = false;
    engineerGroups = [];
    engineerLabel = ViewApplicationProfessionalBodiesEcConstants.ENGINEER_LABEL;
    engineerShowGroupsDropdown = false;
    contractorDisableFilterBy = true;
    contractorDisableAdd = true;
    contractorDisableEditing = false;
    contractorShowFields = true;
    contractorIsInternal = false;
    contractorGroups = [];
    contractorLabel = ViewApplicationProfessionalBodiesEcConstants.ELECTRICAL_CONTRACTOR_LABEL;
    contractorShowGroupsDropdown = false;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.initialiseDefaultValues();
    }
    loadMetadata(stepMeta) {
        try {
            this.engineerGroups = stepMeta.engineerGroup;
            this.contractorGroups = stepMeta.electricalContractorGroup;
            this.populateProfessionalBodiesForms();
            this.changeDetectorRefs.markForCheck();
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    initForm() {
        this.professionalBodiesForm = this.aflaModuleStrategyService.form.get(this.professionalBodiesFormControlName);
    }
    populateProfessionalBodiesForms() {
        this.populateEngineer(this.selectedApplication);
        this.populateElectricalContractor(this.selectedApplication);
    }
    handleRouteChange() {
    }
    populateEngineer(selectedApplication) {
        if (selectedApplication.engineer && selectedApplication.engineer.length > 0) {
            this.showEngineer = true;
            const engineer = selectedApplication.engineer[0];
            this.professionalBodiesForm.get(this.engineerFormControlName).setValue(engineer);
            this.professionalBodiesForm.get(this.engineerFormControlName).disable();
        }
        else {
            this.professionalBodiesForm.get(this.engineerFormControlName).disable();
            this.showEngineer = false;
        }
    }
    populateElectricalContractor(selectedApplication) {
        if (selectedApplication.electricalContractor && selectedApplication.electricalContractor.length > 0) {
            this.showElectricalContractor = true;
            const electricalContractor = selectedApplication.electricalContractor[0];
            this.professionalBodiesForm.get(this.contractorFormControlName).setValue(electricalContractor);
            this.professionalBodiesForm.get(this.contractorFormControlName).disable();
        }
        else {
            this.professionalBodiesForm.get(this.contractorFormControlName).disable();
            this.showElectricalContractor = false;
        }
    }
    initialiseDefaultValues() {
        this.professionalBodiesForm.get(this.markEngineerAsRequiredFormControlName).setValue(false);
        this.professionalBodiesForm.get(this.markElectricalContractorAsRequiredFormControlName).setValue(false);
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationProfessionalBodiesEcComponent = __decorate([
    Component({
        selector: "app-view-application-professional-bodies-ec",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationProfessionalBodiesEcComponent);
export { ViewApplicationProfessionalBodiesEcComponent };
